<template>
  <div class="indexMicro">
    <Menu mode="horizontal" active-name="1">
      <MenuItem name="1">学堂微课</MenuItem>
    </Menu>
    <div class="lookmore" @click="viewMore('MicroClass')">查看更多
      <Icon type="ios-arrow-forward" />
    </div>
    <div class="microcontentbox">
      <div class="microLeft">
        <img src="/static/images/indexMicro.png" alt="">
        <div class="lookmoreBtn" @click="viewMore('MicroClass')">点击进入</div>
      </div>
      <div class="microRight">
        <div class="microClassList">
          <Row :gutter="18" v-for="(item,index) in microList" :key="index" style="margin-bottom:10px;">
            <Col span="6" v-for="(n,m) in item" :key="m">
            <div class="microBox" @click="videoPlayer(n.videoId,n.name,1,n.id)" :title="n.name">
              <div class="microImgBox">
                <img class="microImgINDexMicro" :src="imgurl+ n.imgurl" alt="">
                <div class="mengBox">
                    <img src="/static/images/mengImg.png" alt="" class="meng">
                </div>
              </div>
              <div class="microMsg">
                <div class="microTitle" :title="n.name">{{n.name}}</div>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <message v-show="isShowMessage" :msg="msg" @isShowMsg="isShowMsg" :isShowMessage="isShowMessage"></message>
  </div>
</template>

<script>
  import api from '../../utils/api.js';
  import bus from '../../assets/eventBus/enentBus.js';
  import message from '../Message/Message'
  import cookie from '../../assets/getCookie.js'
  import isLogin from '../../assets/isLogin.js'
  export default {
    name: 'IndexMicro',
    data() {
      return {
        urlHttp:'/testIp',
        microList:null,                                         //微课列表  array
        imgurl:'https://qcban.aixuetang.com/res/',              //微课图片地址  线上域名
        isShowMessage:false,
        msg:null,
        shareSchoolId:null,
        teacherId:null,
        userType:null,
        documentHeight:'',
        documentWidth:''
      }
    },
    mounted() {
       this.websiteId = localStorage.getItem('websiteId');
       console.log(this.websiteId,'首页微课')
        const cookie_token = cookie.getCookie('AXY_'+ this.websiteId +'_access_token')
        if(cookie_token){
            if(cookie_token != 'null'){
                //console.log('以登录',cookie_token)
                this.shareSchoolId = localStorage.getItem('schoolId');
                this.teacherId = localStorage.getItem('userId');
                this.userType = localStorage.getItem('userType')
            }
        }else{
            //console.log('未登录',cookie_token)
            this.shareSchoolId = null;
            this.teacherId = null;
        }
      this.getIndexMicroData()
    },
    updated(){
        // this.documentHeight = this.$refs.ImgBoxWidth0[0].clientWidth*9/16+'px';
        // this.documentWidth = this.$refs.ImgBoxWidth0[0] +'px';
        //console.log('图片宽度',this.$refs.ImgBoxWidth0[0].clientWidth)
    },
    methods: {
      //获取微课列表
      getIndexMicroData() {
        const that = this;
        const result = [];
        const url = '/axt-future/knowledgeVideo/pageKnowledgeVideosByCondition';
        const params = {
          pageSize: 50,
          pageNo: 1,
          gradeIds: null,
          subjectId: null,
          versionId: null,
          distinct_videoId:1,
          websiteId:this.websiteId
        }
       // console.log(params,"params")
        api.getListAPI(url, params).then(res => {
          // console.log('indexmicro',res.data)
          if (res.data.success) {
           // const microList = res.data.data.rows;
            const microList = that.getArrayItems(res.data.data.rows,8);
            for (let i = 0; i < 8; i += 4) {

              result.push(microList.slice(i, i + 4));
            }
            that.microList = result;
           // console.log('microlist', that.microList)
          }else{
            // that.$Message.error(res.data.message);
            that.microList = []
          }
        })
      },
      viewMore(name) {
        //console.log(name)
        this.$router.push({
          name: name
        });
        this.$emit('routerMicroName', name);
        this.$nextTick(()=>{
          $("body").scrollTop(0);
        })
      },
      getArrayItems(arr, num){
        var temp_array = new Array();
        for (var index in arr) {
            temp_array.push(arr[index]);
        }
        var return_array = new Array();
        for (var i = 0; i<num; i++) {
            if (temp_array.length>0) {
                var arrIndex = Math.floor(Math.random()*temp_array.length);
                return_array[i] = temp_array[arrIndex];
                temp_array.splice(arrIndex, 1);
            } else {
                break;
            }
        }
        return return_array;
      },
      //点击播放
      videoPlayer(videoId,name,sourse,id){
        const ss = isLogin.isLogin();
        console.log('权限',ss)
        if(ss == null){
            this.isShowMessage = true;
            this.msg = ('您尚未登录');
            this.tabType = number;
            return
        }
        this.$emit('showPlayer',true)
        const vidoeData = {
          videoId:videoId,
          name:name,
          sourse:sourse,
          id:id
        }
        this.$nextTick(() => {
            bus.$emit('videoId',vidoeData)
        })

      },
      isShowMsg(msg){
          this.isShowMessage = false;
      }
    },
    components:{message}
  }
</script>

<style >
  .indexMicro {
    position: relative;
    padding-bottom: 30px;
  }

  .indexMicro .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    border-bottom: 3px solid #2d8cf0;
  }
  .indexMicro .ivu-menu {
    z-index: 0;
  }
  .lookmore {
    position: absolute;
    right: 0;
    top: 7px;
    font-size: 14px;
    height: 30px;
    line-height: 28px;
    padding: 0 10px 0 15px;
    /* border-radius: 16px;
    border: 1px solid #2d8cf0; */
    color: #2d8cf0 !important;
    cursor: pointer;
  }
  /* .lookmore:hover{
    background: #2d8cf0;
    color: #fff!important;
  } */
  .microcontentbox {
    display: flex;
    flex-direction: row;
    margin-top: 22px;
  }
  .microBox {
    border-radius:4px;
    overflow: hidden;
  }
  .microLeft {
    width: 17%;
    height: 328px;
    margin-right: 1%;
    text-align: left;
    position: relative;
    overflow: hidden;
    border-radius: 6px;
  }

  .microRight {
    width: 82%;
  }

  .microLeft img {
    height: 100%;
    position: absolute;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%,-50%);
    /* height: 484px; */
  }

  .microLeft .lookmoreBtn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 20%;
    line-height: 37px;
    padding: 0 15px;
    border-radius: 20px;
    background-color: #fff;
    font-size: 14px;
    cursor: pointer;
    color: #6B7AFE;
  }
   .microLeft .lookmoreBtn:hover{
     transform:translateX(-50%) scale(1.2) ;
   }
  .microBox:hover {
    cursor: pointer;
  }

  .microBox:hover {
    /* margin-top: -10px;
    box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37); */
    animation: ImgHovers .3s forwards;
  }
  @keyframes ImgHovers{
      form{margin-top: 0;box-shadow: 0px 0px 17px 0px rgba(255,255,255,0);}
      to{margin-top:-5px;box-shadow: 0px 0px 17px 0px rgba(133, 137, 160, 0.37);}
  }
  .microBox:hover .microTitle {
    color: #3683FF;
  }

  .indexMicro .microImgBox {
    /* height: 200px!important; */
    /* display: table-cell;
    vertical-align: bottom; */
    position: relative;
    height: 123px;
    width: 100%;
  }
  .indexMicro .microImgBox img {
    display: block;
  }
  .indexMicro .microImgINDexMicro {
    width:100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .microImgHover {
    display: inline-block;
    border-radius: 4px;
  }
  .indexMicro .ivu-menu-horizontal {
    height: 45px;
    line-height: 45px;
  }

  .microMsg {
    margin-top: 5px;
    /* margin-bottom: 10px; */
    text-align: left;
  }

  .microTitle {
    width: 100%;
     padding-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    color: #34495E;
    font-weight: 500;
  }
  .microbox .ivu-row:last-of-type {
    margin-bottom: 0!important;
  }
  /* 蒙版  */
  .mengBox{
      width:100%;
      height: 100%;
      position: absolute;
      left: 0;
      top:0;
      z-index: 10;
      background:rgba(255, 255, 255, 0);
      border-radius: 4px;
  }
  .mengBox img{
      position: absolute;
      left: 50%;
      top: 50%;
      /* transform: translate(-50%,-50%); */
      margin-left: -33px;
      margin-top: -33px;
      opacity: 0;
  }
  .microBox:hover .mengBox{
      animation: mengHovar .3s forwards;
  }
  .microBox:hover .mengBox img{
      animation: mengImgHovar .3s forwards;
  }
  @keyframes mengHovar{
      from {background: rgba(255, 255, 255, 0);}
      to {background: rgba(0, 0, 0, 0.3);}
  }
  @keyframes mengImgHovar{
      from {opacity: 0;transform: scale(2);}
      to {opacity: 1;transform: scale(1);}
  }
  .indexMicro .ivu-menu-horizontal .ivu-menu-item {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/IndexMicro.vue